/*
Copyright (c) 2018-2019 Qualcomm Technologies, Inc.
All rights reserved.
Redistribution and use in source and binary forms, with or without modification, are permitted (subject to the limitations in the 
disclaimer below) provided that the following conditions are met:
    * Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer 
      in the documentation and/or other materials provided with the distribution.
    * Neither the name of Qualcomm Technologies, Inc. nor the names of its contributors may be used to endorse or promote 
      products derived from this software without specific prior written permission.
    * The origin of this software must not be misrepresented; you must not claim that you wrote the original software. If you use 
      this software in a product, an acknowledgment is required by displaying the trademark/log as per the details provided 
      here: https://www.qualcomm.com/documents/dirbs-logo-and-brand-guidelines
    * Altered source versions must be plainly marked as such, and must not be misrepresented as being the original software.
    * This notice may not be removed or altered from any source distribution.
NO EXPRESS OR IMPLIED LICENSES TO ANY PARTY'S PATENT RIGHTS ARE GRANTED BY THIS LICENSE. THIS SOFTWARE IS PROVIDED 
BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT 
LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO 
EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, 
EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; 
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN 
CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS 
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
import { operatorOne, operatorTwo, operatorThree, operatorFour, operatorFive, operatorSix } from './helpers';

export const individualBarColors = [
    "#0BDDDE", "#0093C7"
]

export const stackBarBlueShades = [
    "#0477BF", "#048ABF", "#0DB3D9", "#84C9D9", "#F2F2F2"
]

export const stackBarAnalogic = [
    "#FFFFFF", "#049DBF", "#0BDDDE", "#0DD9C4", "#0093C7"
]

export const stackBarPurpleColors = [
    "#A28BD3", "#D897D7", "#99DAB0", "#E9C69E", "#A9B7E8"
]

export const stackBarReverswPurple = [
    "#C9D893", "#9A8ED6", "#92D8BE", "#D78FA7", "#BC8ED7"
]

export const stackBarMono = [
    "#F24464", "#7162D9", "#0597F2", "#04D98B", "#F2911B"
]

export const stackBarLightTraide = [
    "#3C89D9", "#92D7C3", "#FDD969","#7BBEF5", "#EF8026"
]

export const stackBarYellowTraide = [
    "#F7DD70", "#32C5BB", "#D0EEF9", "#FF9561", "#85D6E9"
]

export const stackBarTetrade = [
    "#A4E8DF", "#1CC8DC", "#6F83C8"
]

export const stackBarGrayToGreen = [
    "#E2F2B3", "#D1E697", "#C2DB7F", "#A5E8E1", "#ABBC78"
]

export const stackBarLightBlueToDark = [
    "#77BDFC", "#2777B4", "#60A4E3", "#ACEBFD", "#468EC9"
]

export const stackBarBlueToGray = [
    "#49C2F2", "#49D3F2", "#F2C641", "#F2D680", "#F2F2F2"
]

export const stackBarBlueToGraySecond = [
    "#91CDF2", "#49C2F2", "#49D3F2", "#79E6F2", "#F2F2F2"
]

export const StackColorsCombination = [
    "#45B7E0", "#0476D0", "#2CEEF0", "#B4F5F0", "#059DC0", "#04D4F0",
    "#1CA6A0", "#09C1D0", "#56C0F0", "#1DB3C0", "#31CCE0", "#4DDDE0",
    "#D5D5C0", "#426250", "#39D3E0", "#98E8E0", "#CAEEE0", "#07DAC0"
]

export const StackColorsSkin = [
    "#A7D477", "#FF9E02", "#EED466", "#A84D04", "#F3C381"
]

export const StackColorsRedToGreen = [
    "#FFCCD1",  "#B4D97E", "#A7D477",
]

export const NumerousColors = [
    "#F24464", "#7162D9", "#0597F2", "#04D98B", "#F2911B",
    "#FFCCD1", "#66BCF2", "#B4D97E", "#A7D477", "#65B4F6"

]

export const NumerousColorsSecond = [
    "#F24464", "#7162D9", "#0597F2", "#04D98B", "#F2911B",
    "#FFCCD1", "#66BCF2", "#B4D97E", "#A7D477", "#65B4F6"

]

export const stackBarTwentyColors = [
    "#15223F","#1E3953","#275067", "#31677A","#3A7E8E",
    "#4395A2","#4CACB6","#56C3C9","#5FDADD","#68F1F1",
    "#3C7F64","#438C6F","#4B9A79","#52A784","#5AB48F",
    "#61C299","#69CFA4","#70DCAF","#78EAB9","#7FF7C4"
]

export const stackBarTenColors = [
    "#067302","#187E0C","#2A8A16","#3B9520",
    "#4DA02A","#5FAC33","#71B73D","#82C247",
    "#94CE51","#A6D95B"
]

export const stackBarFiveColors = [
    "#4d382a", "#6f523a", "#967559", "#bf9776","#eacfaf"
]

export const multiColorStack = [
    "#00B1D2","#2AB8B5","#55BF99","#7FC67C",
    "#A9CD60","#D4D443","#FEDB27","#FFA350",
    "#FFB166","#FFBE7C","#F7CC76","#EED970",
    "#A8D4B9","#8BBEE9","#D6A9E2",
    "#3A7E8E",
    "#4395A2","#4CACB6","#56C3C9","#5FDADD","#68F1F1",
    "#3C7F64","#438C6F","#4B9A79","#52A784","#5AB48F",
    "#61C299","#69CFA4","#70DCAF","#78EAB9","#7FF7C4",
    "#067302","#187E0C","#2A8A16","#3B9520",
    "#4DA02A","#5FAC33","#71B73D","#82C247",
    "#94CE51","#A6D95B"
]

export const purpleColorStack = [
    "#A16FB1","#B97BC9","#D287E1","#EA93F9",
    "#F0B0FB","#F5CCFC","#FBE9FE"
]

export const AreaChartColors = [
    "#FEDB27", "#29ABE2"
]

export const BoxesColors = [
    "#0B6EDE", "#0BDDDE", "#F07C7C", "#0BD49C",
    "#FEAC55", "#ED6364"
]

export const purpleShades = [
    "#0B6EDE", "#388BE6","#65A8EF","#93C6F7",
    "#C0E3FF"
]

export const blueColors = [
    "#009ACD","#50BADD","#0093C7","#28A7D2","#50BADD","#78CEE7",
    "#A0E1F2"
]

export const PinkColors = [
    "#F07C7C","#F49595","#F8ADAD","#FBC6C6",
    "#FFDEDE"
]

export const greenColors = [
    "#0BD49C","#3DDDB0","#6FE7C4","#A0F0D8",
    "#D2F9EC"
]

export const orangeColors = [
    "#FEAC55","#FEBB75","#FDC996","#FDD8B6",
    "#FCE6D6"
]

export const redColors = [
    "#ED6364","#F18081","#F59C9F","#F8B9BC",
    "#FCD6DA"
]


export const multiColors = [
    "#0B6EDE", "#388BE6","#65A8EF","#93C6F7","#C0E3FF",
    "#F07C7C","#F49595","#F8ADAD","#FBC6C6","#FFDEDE",
    "#0093C7","#28A7D2","#50BADD","#78CEE7","#A0E1F2",
    "#0BD49C","#3DDDB0","#6FE7C4","#A0F0D8","#D2F9EC",
    "#FEAC55","#FEBB75","#FDC996","#FDD8B6","#FCE6D6",
    "#ED6364","#F18081","#F59C9F","#F8B9BC","#FCD6DA",
    "#00B1D2","#2AB8B5","#55BF99","#7FC67C","#A9CD60",
    "#D4D443","#FEDB27","#FFA350","#FFB166","#FFBE7C",
    "#F7CC76","#EED970","#A8D4B9","#8BBEE9","#D6A9E2",
    "#3A7E8E","#4395A2","#4CACB6","#56C3C9","#5FDADD",
    "#68F1F1","#3C7F64","#438C6F","#4B9A79","#52A784",
    "#5AB48F","#61C299","#69CFA4","#70DCAF","#78EAB9",
    "#7FF7C4","#067302","#187E0C","#2A8A16","#3B9520",
    "#4DA02A","#5FAC33","#71B73D","#82C247","#94CE51",
    "#A6D95B","#15223F","#1E3953","#275067", "#31677A","#3A7E8E",
    "#4395A2","#4CACB6","#56C3C9","#5FDADD","#68F1F1",
    "#3C7F64","#438C6F","#4B9A79","#52A784","#5AB48F",
    "#61C299","#69CFA4","#70DCAF","#78EAB9","#7FF7C4",
    "#45B7E0", "#0476D0", "#2CEEF0", "#B4F5F0", "#059DC0", "#04D4F0",
    "#1CA6A0", "#09C1D0", "#56C0F0", "#1DB3C0", "#31CCE0", "#4DDDE0",
    "#D5D5C0", "#426250", "#39D3E0", "#98E8E0", "#CAEEE0", "#07DAC0"
]

export const blueShadsColors = [
    "#006B93","#0086B7","#2EA6D2","#73C4E1",
    "#A2D7EB"
]

export const operatorColors = [
    operatorThree, operatorFive, operatorOne, operatorTwo,  operatorFour,  operatorSix
]

export const dashboardDRSIMEIs = [
    "#FFFFFF", "#0BD49C"
]

export const barBgColors = [
    "#0093C7", "#0BD49C", "#ED6364"
]

export const colorIMEIsPairing = [
    "#2DCD7A", "#0BD49C"
]

export const progressBarColors = [
    "#FEAC55", "#ED6364", "#0093C7", "#A0D8E6", "#37AFC8"
]

export const statusColors = [ "#0093C7", "#0BD49C" ,"#ED6364"]

export const statusColorsForBlueBG = [  "#0093C7" ,"#ED6364",  "#ffff87"]

export const pairStatusColors = [
    "#0093C7", "#0BD49C", "#ED6364", "#FEAC55"
]

export const statusColorArray = [
    {
        "name": "permanent",
        "color": "#0093c7"
    },
    {
        "name": "pending",
        "color": "#0093c7"
    },
    {
        "name": "active",
        "color": "#0abb89"
    },
    {
        "name": "recovered",
        "color": "#0abb89"
    },
    {
        "name": "deleted",
        "color": "#ED6364"
    },
    {
        "name": "blocked",
        "color": "#ED6364"
    },
    {
        "name": "temporary",
        "color": "#feac55"
    },
]